module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "ch002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-002"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-002"
    }
  }, [_vm._v("God’s Mission and Evangelism")])]), _vm._v(" "), _c('p', {
    staticClass: "Vl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Mission originates with the triune God—Father, Son, and Holy Spirit. The biblical narratives tell of God’s mission in, through, and for the sake of the world. This mission is both verbal ("), _c('i', [_vm._v("verborum")]), _vm._v(") and operative ("), _c('i', [_vm._v("operatus")]), _vm._v("); God speaks and acts. Missiologist David J. Bosch (1929–1992) said, “Mission has its origin in the heart of God. God is a fountain of sending love. This is the deepest source of mission.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" God speaks, creates, acts, seeks, calls, reveals, leads, sends, redeems, sanctifies, gifts, and restores. Thus, mission is not first and foremost an activity of the church but an attribute of God; God is missional."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The mission of God ("), _c('i', [_vm._v("missio Dei")]), _vm._v(") is to establish his reign on earth as it is in heaven (Matt. 6:10)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" The mission of God consists of the creation of the world and the redemption of humankind, affecting every realm of human life including the spiritual, moral, intellectual, social, and physical. God’s mission centers on his Son, Jesus Christ, who redeems and makes all things new."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The church’s mission ("), _c('i', [_vm._v("missio ecclesiae")]), _vm._v(") is an outworking of the mission of God in the world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" Jesus said to his disciples, “As the Father has sent me, I am sending you” (John 20:21). The church is sent to testify to Jesus’s kingly reign and redemptive work in the world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" In this way, the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" of the Father "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("sending the Son, and the Father and Son sending the Spirit, is expanded to the Father, Son, and Holy Spirit sending the church into the world."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v(" As Karl Barth (1886–1968) said, “[The church’s] mission is not additional to its being. It is, as it is sent and active in its mission. It builds up itself for the sake of its mission and in relation to it.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" Jürgen Moltmann says, “It is not the church that has a mission of salvation to fulfill in the world; it is the mission of the Son and the Spirit through the Father that includes the church, creating a church as it goes on its way.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")])]), _vm._v(" Thus, we are instruments of God, and we exist not for ourselves but for his glory, purposes, and mission. Gospel witness finds its place within the "), _c('i', [_vm._v("missio Dei")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" It is not a task that God does himself. Rather, he calls his church to participate with him in this work.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Some have suggested that unless the church decides to carry out its mission, the mission will not be accomplished."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" However, God’s purpose of redemption is not conditioned on the church’s performance, which somehow might leave the "), _c('i', [_vm._v("missio Dei")]), _vm._v(" in jeopardy."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" What is at risk is our opportunity to participate in what God is doing in the world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" If God saw fit, he could use stones, animals, or angels to proclaim his gospel."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" Nevertheless, he chooses to use us, redeemed human beings, weak and sinful as we are.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Two Mandates")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The mission of God finds expression in two mandates to humans, whom God calls to participate in his work on earth. First, his mission is expressed in "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("the "), _c('i', [_vm._v("creation mandate")]), _vm._v(", also called the "), _c('i', [_vm._v("culture mandate")]), _vm._v(" given to all humanity in union with the first human, Adam (Gen. 1:28; 2:15). As humans, we are created to be fruitful and multiply, to rule over the earth, to care for God’s creation and creatures, and to maintain order, peace, and justice in the world.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bx-indentb"
  }, [_vm._v("How Does the New Testament Describe the Fallen Human Condition?")]), _vm._v(" "), _c('ul', {
    staticClass: "blist1"
  }, [_c('li', [_vm._v("Matt. 13:40–42")]), _vm._v(" "), _c('li', [_vm._v("John 3:18–20, 36")]), _vm._v(" "), _c('li', [_vm._v("Rom. 1:18, 28–32")]), _vm._v(" "), _c('li', [_vm._v("Rom. 3:23")]), _vm._v(" "), _c('li', [_vm._v("Rom. 5:12")]), _vm._v(" "), _c('li', [_vm._v("Rom. 6:23a")]), _vm._v(" "), _c('li', [_vm._v("1 Cor. 11:7b")]), _vm._v(" "), _c('li', [_vm._v("1 Cor. 15:22a")]), _vm._v(" "), _c('li', [_vm._v("Eph. 2:1–3")]), _vm._v(" "), _c('li', [_vm._v("Eph. 4:17–19")]), _vm._v(" "), _c('li', [_vm._v("2 Thess. 1:8, 9")]), _vm._v(" "), _c('li', [_vm._v("Titus 1:15")]), _vm._v(" "), _c('li', [_vm._v("Titus 3:3")]), _vm._v(" "), _c('li', [_vm._v("James 3:9c")]), _vm._v(" "), _c('li', [_vm._v("Jude 5–7")]), _vm._v(" "), _c('li', [_vm._v("Rev. 20:14–15")]), _vm._v(" "), _c('li', [_vm._v("Rev. 21:8")])])])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Second, his mission to redeem humankind is expressed in the "), _c('i', [_vm._v("disciple-making mandate")]), _vm._v(", also called the "), _c('i', [_vm._v("gospel mandate")]), _vm._v(", given to the church, to new humanity in union with Christ, the second Adam."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(" We are created in Christ Jesus to announce the gospel, the good news ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐαγγέλιον")]), _vm._v(", "), _c('i', [_vm._v("euangelion")]), _vm._v("), to all creation, with a view to making disciples of all nations."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])]), _vm._v(" We participate in this mission by bearing witness to the reign and redeeming work of God in Christ, and inviting others to be reconciled to him (2 Cor. 5:17–20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Thus, these two mandates—the cultural mandate and disciple-making mandate— come together in word and deed in the mission of the church."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" They express the doctrines of God and humanity, love for neighbor, and "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("obedience to Jesus Christ."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(" As we participate with God in his mission in the world, we engage in the spiritual, moral, intellectual, social, and physical realms, acting to restrain sin and injustice and proclaiming the message of reconciliation to sinners who are estranged from him. Verbal witness to the gospel is embodied in practical demonstrations of love that address human needs. We communicate the good news of Jesus Christ, challenge sin and evil actions, offer hope in Christ, and summon listeners to new life in God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The scope of the church’s mission is to make disciples of all nations ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("πάντα τὰ ἔθνη")]), _vm._v(", "), _c('i', [_vm._v("panta ta ethnē")]), _vm._v(") to the ends of the earth until the end of the age (Matt. 28:19–20; Acts 1:8)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")])]), _vm._v(" All categories of humanity—every tribe ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("φυλῆς")]), _vm._v(", "), _c('i', [_vm._v("phylēs")]), _vm._v("), language ("), _c('span', {
    staticClass: "grk"
  }, [_vm._v("γλώσσης")]), _vm._v(", "), _c('i', [_vm._v("glōssēs")]), _vm._v("), people ( "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("λαοῦ")]), _vm._v(", "), _c('i', [_vm._v("laou")]), _vm._v("), and nation ( "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("ἔθνους")]), _vm._v(", "), _c('i', [_vm._v("ethnous")]), _vm._v(")—will be reached (Rev. 5:9), with some of each becoming part of new humanity in Christ."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")])]), _vm._v(" This mission is both geographical and generational, encompassing all people of the earth in every generation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The goal of gospel witness is that hearers will turn from sin, self, and spurious gods; believe that Jesus is the Christ, the Son of God; and by believing have life in his name (John 20:30–1). The apostle John writes, “To all who did receive him [Jesus, the Word], who believed in his name, he gave the right "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("to become children of God, who were born, not of blood nor of the will of the flesh nor of the will of man, but of God” (John 1:12–3 ESV). By believing, the Christian disciple is united with Christ in his death and resurrection and becomes a “new creation” (Rom. 6:5; 2 Cor. 5:17).")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("This new birth brings reorientation and redirection (Matt 3:2, 8; 16:24). Thus, a Christian disciple is a person who believes "), _c('i', [_vm._v("in")]), _vm._v(" and follows "), _c('i', [_vm._v("after")]), _vm._v(" Jesus Christ, living under his reign, abiding in his teachings, and practicing his ways (John 14:15–23)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v(" As Dietrich Bonhoeffer (1906–1945) said, “Only he who believes is obedient, and only he who is obedient believes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" The gospel calls the believer to bring all of her life under Christ and his saving lordship (Acts 2:36). A Christian disciple knows the triune God and grows in faith, knowledge, and obedience as she walks the path of discipleship."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" Thus, the goal of gospel witness is “to turn irreligious people into fully-devoted followers of Jesus Christ.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Proclaiming the gospel is instrumental to the church’s task of disciple-making. The apostle Paul asked, “How, then, can they call on the one they have not believed in? And how can they believe in the one of whom they have not heard? And how can they hear without someone preaching to them? And how can they preach unless they are sent? As it is written: ‘How beautiful are the feet of those who bring good news!’ ” (Rom. 10:14–5).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Evangelism is the verbal proclamation of the person and claims of Jesus, communicated by words that are meaningful to listeners."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27",
      "id": "fn27"
    }
  }, [_vm._v("27")])]), _vm._v(" David Bosch describes evangelism as “the core, heart, or center” of mission."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28",
      "id": "fn28"
    }
  }, [_vm._v("28")])]), _vm._v(" It consists in proclaiming salvation in Christ to nonbelievers, announcing forgiveness of sins, calling people to repentance and faith in Christ, and inviting them to become living members of Christ’s earthly community and to begin a life in the power of the Holy Spirit. Thus, evangelism is an "), _c('i', [_vm._v("introduction")]), _vm._v(" to a relationship with the triune God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29",
      "id": "fn29"
    }
  }, [_vm._v("29")])]), _vm._v(" It is an "), _c('i', [_vm._v("invitation")]), _vm._v(" to the life of a Christian "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("disciple, believing in and following the ways of Jesus."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(" And it is a means of "), _c('i', [_vm._v("initiation")]), _vm._v(" into the kingdom of God through faith in Jesus Christ."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31",
      "id": "fn31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While the essence of evangelism is communicating the person and work of Jesus Christ, the goal is to make disciples."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32",
      "id": "fn32"
    }
  }, [_vm._v("32")])]), _vm._v(" We present the gospel so that those who hear may be converted and follow him. Conversion is a process with a turning point marked by a crisis moment of repentance and belief. Thus, gospel witness should not be viewed as a once-for-all activity but as a series of activities alongside the process of conversion that leads to making disciples of Jesus."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33",
      "id": "fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" The process includes sowing the seed of the Word of God, watering it, and allowing time for it to germinate, grow, and ripen for harvest. Each event, in which we partner with the Holy Spirit, moves toward the end that sinners will come to saving faith in Jesus Christ and live as his disciples in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Imago Dei and Human Sin")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Because the triune God is divine-persons-in-relation, love, community, and relationship are intrinsic to his being."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34",
      "id": "fn34"
    }
  }, [_vm._v("34")])]), _vm._v(" God has a disposition toward abundant self-communication; he is profoundly relational. Therefore, he created humans in his image and likeness, to mirror or reflect him in the world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35",
      "id": "fn35"
    }
  }, [_vm._v("35")])]), _vm._v(" As such, we are rational, moral, emotional, and social beings able to communicate, "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("exercise conscience, and show love."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v(" We are artistic creatures able to create and appreciate beauty."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37",
      "id": "fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" We are spiritual beings able to worship and pray.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first human, Adam, participated in God’s reign with responsibility to rule over the earth, specifically to cultivate the garden. Genesis 2:15 says, “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God took the man and put him in the Garden of Eden to work [cultivate] it and take care of [keep] it.” Adam’s ability to cultivate the earth stemmed from the fact that he was created in the image of God ("), _c('i', [_vm._v("imago Dei")]), _vm._v("). Adam’s ability to cultivate was practiced immediately, first in agriculture (working the garden) and then in language (naming the animals). Such culture-creating activities soon expanded to other areas of human endeavor such as the arts, government, science, technology, and economics (Gen. 4–10)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38",
      "id": "fn38"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, when Adam and Eve ate of the tree of the knowledge of good and evil and disobeyed God, they rejected his rule and reign and usurped his authority over their lives (Gen. 3:6)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39",
      "id": "fn39"
    }
  }, [_vm._v("39")])]), _vm._v(" This was an act of self-deification, setting themselves up as divine in the place of God (Gen. 3:5). By this act of betrayal, prompted by pride or self-interest, Adam and Eve fell from their state of holy innocence and were damaged by sin. In this egocentric (self-centered) rather than theocentric (God-centered) act, they succumbed to the serpent’s temptation and to the pretense of being people other than who they were.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For the first time Adam and Eve knew fear, shame, and guilt and responded with self-justification, evading moral responsibility before God and blaming others, the serpent who deceived them, and even God himself (Gen. 3:8–13)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40",
      "id": "fn40"
    }
  }, [_vm._v("40")])]), _vm._v(" They no longer mirrored or reflected God’s image as in their original state. The image of God was marred, distorted, and warped, but not destroyed (Gen. 9:6; James 3:9)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41",
      "id": "fn41"
    }
  }, [_vm._v("41")])]), _vm._v(" Thus, our human state is described now as simultaneously created and sinner ("), _c('i', [_vm._v("simul creatus et peccator")]), _vm._v("). Despite our "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("rebellion, the image of God has remained in us but is now distorted, like a broken mirror that no longer reflects the divine subject perfectly.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bx-indentb"
  }, [_vm._v("How Does the New Testament Describe the Reconciled Human Condition?")]), _vm._v(" "), _c('ul', {
    staticClass: "blist1"
  }, [_c('li', [_vm._v("Matt. 5:13–14")]), _vm._v(" "), _c('li', [_vm._v("John 1:12")]), _vm._v(" "), _c('li', [_vm._v("John 15:16")]), _vm._v(" "), _c('li', [_vm._v("Rom. 5:1")]), _vm._v(" "), _c('li', [_vm._v("Rom. 8:1–2")]), _vm._v(" "), _c('li', [_vm._v("1 Cor. 6:19–20")]), _vm._v(" "), _c('li', [_vm._v("1 Cor. 3:16")]), _vm._v(" "), _c('li', [_vm._v("2 Cor. 1:21–22")]), _vm._v(" "), _c('li', [_vm._v("2 Cor. 5:17–21")]), _vm._v(" "), _c('li', [_vm._v("2 Cor. 6:11")]), _vm._v(" "), _c('li', [_vm._v("Eph. 1:1; 2:10")]), _vm._v(" "), _c('li', [_vm._v("Phil. 3:20")]), _vm._v(" "), _c('li', [_vm._v("Col. 1:14")]), _vm._v(" "), _c('li', [_vm._v("Col. 2:10")]), _vm._v(" "), _c('li', [_vm._v("Col. 3:3")]), _vm._v(" "), _c('li', [_vm._v("1 John 5:18")])])])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("In this fallen and alienated state, Adam and Eve were banished by God from the garden (Gen. 3:23–24). Immediately, their sin and sinfulness affected all other human beings and relationships, as well as all of God’s good creation (Gen. 4). Genesis 6:5 says, “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" saw how great the wickedness of the human race had become on the earth, and that every inclination of the thoughts of the human heart was only evil all the time.” Later the psalmist wrote, “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" looks down from heaven on the children of man, / . . . They have all turned aside; together they have become corrupt; / there is none who does good, / not even one” (Ps. 14:2–3 ESV)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42",
      "id": "fn42"
    }
  }, [_vm._v("42")]), _vm._v(" In the words of Augustine of Hippo (354–430), the entire human race had become a “mass of corruption ("), _c('i', [_vm._v("massa perditionis")]), _vm._v(").”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43",
      "id": "fn43"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Despite human betrayal and rebellion, “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God called to the man, ‘Where are you?’ ” (Gen. 3:9). While Adam and Eve hid from God, he called to them, initiating reconciliation with them. The triune God who is perfectly holy and wholly loving never contradicts or compromises his love and holiness. Thus, he speaks to them words that are described as the "), _c('i', [_vm._v("proto-evangelium")]), _vm._v(", or first gospel, found in Genesis 3:15. Christian interpreters have understood these words of God to say: “And I will put enmity between you (serpent/Satan) and the woman (Eve/Mary), and between your seed (demons) and hers (humans/Jesus Christ); he (Jesus Christ) will crush your head (fatal destruction), and you (Satan) will strike his heel (crucifixion).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44",
      "id": "fn44"
    }
  }, [_vm._v("44")])]), _vm._v(" In this "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("statement, God announced the future work of the restoration of all creation through Jesus Christ.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Furthermore, we read in this passage that “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God made garments of skin for Adam and his wife and clothed them” (Gen. 3:21). In response to Adam and Eve’s ashamed and guilty condition, God provided the skins of sacrificed animals as a covering for their nakedness and self-awareness that came with the personal knowledge of good and evil.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('span', {
    staticStyle: {
      "font-style": "normal"
    }
  }, [_vm._v("Imago Dei")]), _vm._v(" and Human Culture")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("After the fall of Adam and Eve—progenitors of the human race—the culture mandate continued, but humans existed in dissonance and disharmony with the original, good creation (Gen. 3:17). Immediately, sin and its consequences complicated the task to rule, fill, and cultivate the earth (Gen. 4–11). Nevertheless, humans were still to perform the culturative acts given originally to Adam, and these acts continued to have tangible benefits for human life, though now they were accomplished through painful toil and hardship (Gen. 3:17–19).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Ever since their creation, humans have been culture-makers, transforming what God has created, namely, nature ("), _c('i', [_vm._v("natura")]), _vm._v(") into human culture ("), _c('i', [_vm._v("cultura")]), _vm._v(")."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45",
      "id": "fn45"
    }
  }, [_vm._v("45")]), _vm._v(" Human culture is the product of all human thought and acts, an outworking or expression of the image of God in humankind, reflecting God’s goodness, beauty, and righteousness (Gen. 1:26–27). God still calls us to be co-workers with him in carefully nurturing his creation, necessarily developing tools and means of shaping the earth and human society. Thus, the greatest human abilities and achievements—whether composing a music concerto, harvesting a thousand-acre field of wheat with manufactured machinery, building a skyscraper, or launching astronauts to the moon—are possible because humans are created in the image and likeness of God. However, such human accomplishments are not without the effects of the rebellion and betrayal against God that brought sin and suffering into the world.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bx-indentb"
  }, [_vm._v("Human Culture as Good:")]), _vm._v(" "), _c('ul', {
    staticClass: "blist1"
  }, [_c('li', [_vm._v("Is necessary for human life and human flourishing on earth")]), _vm._v(" "), _c('li', [_vm._v("Reflects collectively the "), _c('i', [_vm._v("imago Dei")]), _vm._v(" in humankind")]), _vm._v(" "), _c('li', [_vm._v("Embraces the redeeming aspects of language, technology, agriculture, art, government, cuisine, and sport")]), _vm._v(" "), _c('li', [_vm._v("Refers to that which is good and to be enjoyed within the bounds of God’s Word (e.g., family, friendships, food, drink, work, and sex)")]), _vm._v(" "), _c('li', [_vm._v("Luke 7:34; John 2:10; 1 Cor. 10:31; 1 Tim. 4:4; 6:17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Human culture expresses humanness—human body, mind, and spirit."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v(" It encompasses all that human beings think, say, value, invent, and make. It is the output of human societies, the product of deliberate human activity (texts both written and oral, music, athletics), objects (tools, clothing, art), and structures (roads, buildings, cathedrals)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47",
      "id": "fn47"
    }
  }, [_vm._v("47")])]), _vm._v(" Human culture produces the world of meaning in which we live, a web of significance necessary for human life."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48",
      "id": "fn48"
    }
  }, [_vm._v("48")])]), _vm._v(" To the extent that societies and social systems are good—when they support values of human dignity, marriage, work, family, and justice—they move humans toward wholeness of personhood and toward social systems that God’s image-bearers need for human life and flourishing."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49",
      "id": "fn49"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, while human culture is the out-working of the image of God in humankind and thus of divine worth, ever since the original human rebellion, culture too is fallen, affected by sin and damaged by evil."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50",
      "id": "fn50"
    }
  }, [_vm._v("50")])]), _vm._v(" While we as humans remain culture-makers, in our sinful condition we remain disinterested, apathetic, and even hostile toward God (Rom. 8:7; 1 Cor. 2:14). We take for granted his creation and the good things we receive from it (Rom. 1:21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although in the beginning human culture began as essentially good, sin has distorted it. Rather than serving human well-being, human culture and societies have become oppressive, enslaving, and worldly, leading to "), _c('i', [_vm._v("worldliness")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51",
      "id": "fn51"
    }
  }, [_vm._v("51")])]), _vm._v(" Theologian David F. Wells describes such worldliness as a “system "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("of values, in any given age, which has at its center a fallen human perspective, displacing God and his truth from the world, and which makes sin look normal and righteousness seem strange.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52",
      "id": "fn52"
    }
  }, [_vm._v("52")]), _vm._v(" Thus, fallen human culture no longer conforms to the original creative and culturative intent to reflect God’s goodness, beauty, and righteousness in the world."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53",
      "id": "fn53"
    }
  }, [_vm._v("53")])]), _vm._v(" Rather, the cultural environment that we inhabit is alien to God and his rule—with different priorities and visions of the future (Rom. 1:22–23)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54",
      "id": "fn54"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Therefore, in human history sin and evil began to work against the good of humankind. Hostility, discord, and violence characterized the world at war with itself and with the Creator."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn55",
      "id": "fn55"
    }
  }, [_vm._v("55")])]), _vm._v(" Whereas culture has always been necessary for human life and flourishing, in its warped state it produces injustice, abuse, and oppression."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn56",
      "id": "fn56"
    }
  }, [_vm._v("56")])]), _vm._v(" Sin has become endemic, structural, and embedded in human societies, as it has been rationalized, normalized, and rendered acceptable within cultural patterns (Isa. 10:1–2). It corrupts minds and produces self-interest, whether in racism, sexism, or economic exploitation, permeating social structures and institutions to such a degree that they are a mixture of good and evil."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn57",
      "id": "fn57"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Church and Human Culture")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In order to understand gospel witness in word and deed, we have introduced the cultural mandate and disciple-making mandate along with a theology of human culture."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn58",
      "id": "fn58"
    }
  }, [_vm._v("58")])]), _vm._v(" The biblical and theological foundation is important to understand as we consider the contexts and tasks of mission and evangelism.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bx-indentb"
  }, [_vm._v("Human Culture as Fallen:")]), _vm._v(" "), _c('ul', {
    staticClass: "blist1"
  }, [_c('li', [_vm._v("Sin and evil in culture work against the good of humankind.")]), _vm._v(" "), _c('li', [_vm._v("Whereas culture is necessary for human flourishing, in its fallen state it produces injustice, abuse, and oppression.")]), _vm._v(" "), _c('li', [_vm._v("Its redeeming aspects become distorted, warped, marred, and perverse, producing worldliness.")]), _vm._v(" "), _c('li', [_vm._v("Such worldliness refers to the whole sinful social order that is in systemic rebellion against God (e.g., abuse, gluttony, drunkenness, greed, and fornication).")]), _vm._v(" "), _c('li', [_vm._v("John 15:19; 17:15; Rom. 12:1–2; 1 Cor. 1:20; 2:12; Eph. 2:2; 2 Tim. 4:10; James 1:27; 4:4; 1 John 2:15–17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The question of the ages is: How should the church as the people of God relate to the broader human society and its cultural environment? How should we view human culture? The church father Tertullian of Carthage (160–220) raised an important question when he asked, “What indeed has Athens to do with Jerusalem? What concord is there between the Academy and the Church? What between heretics and Christians? Our instruction comes from ‘the porch of Solomon,’ who had himself taught that ‘the Lord should be sought in simplicity of heart.’ ”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn59",
      "id": "fn59"
    }
  }, [_vm._v("59")]), _vm._v(" Tertullian’s question was taken up by H. Richard Niebuhr (1894–1962), who outlined different perspectives on how the church has related to broader culture throughout history."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn60",
      "id": "fn60"
    }
  }, [_vm._v("60")])]), _vm._v(" I have modified and abbreviated Niebuhr’s typology and present it here in three categories: church separates from culture, church accommodates to culture, and church engages with culture."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn61",
      "id": "fn61"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first perspective is that the church "), _c('i', [_vm._v("separates from")]), _vm._v(" culture. This view sees human culture as worldly and says the church needs to stave off and stand in contrast to worldliness. The apostle James declared, “Religion that God our Father accepts as pure and faultless is this: . . . to keep oneself from being polluted by the world” (James 1:27). With this emphasis, the church withdraws from wider society and gathers in secluded communes or separatist faith communities. Although with this posture the church seeks to remove itself from aspects of human culture such as technology and fashion, "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("it cannot withdraw from all aspects of culture such as human language and agriculture.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The second perspective is that the church "), _c('i', [_vm._v("conforms to")]), _vm._v(" culture. This view celebrates human achievement and progress in history, embracing the wisdom of the nations (Rev. 21:24–27). However, as the church generously adopts and adapts elements of human culture, it becomes less and less distinct from broader society and embraces all of human culture and achievement at a theological and moral cost. With a liberal posture of uncritical acceptance and broad diversity, it forfeits particulars of Christian belief and life. By giving up what makes it distinct, the church has little or nothing distinctive to say.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("The third perspective is that the church "), _c('i', [_vm._v("engages with")]), _vm._v(" culture cautiously and critically—being in the world but not of it."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn62",
      "id": "fn62"
    }
  }, [_vm._v("62")]), _vm._v(" In this mediating view, the church both affirms achievements in the sectors of human culture that are necessary for human life and flourishing, and recognizes the existence of sin and its effects on human societies. Therefore, in this approach the church exercises a discernment of good from evil (Heb. 5:14). It applies the apostle Paul’s admonition to “hate what is evil; cling to what is good” (Rom. 12:9). In other words, the church joins and celebrates the redemptive and beneficial elements of human culture and society but opposes and rejects those elements—including personal, social, and structural elements—that are affected by sin and destructive to human life. It also identifies elements of human culture that can be reformed or transformed, and it labors to that end."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn63",
      "id": "fn63"
    }
  }, [_vm._v("63")])]), _vm._v(" Christopher J. H. Wright says, “So while a missional approach to other cultures will seek to affirm whatever it can there, it will also discern the marks of sin, selfishness and idolatry that infect all cultures. Such discernment cannot be predetermined but comes from long engagement and profound understanding, otherwise we may reject too quickly and without sympathetic understanding that which is merely strange or exotic to ourselves.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn64",
      "id": "fn64"
    }
  }, [_vm._v("64")])]), _vm._v(" Wright advocates an engagement that affirms all that is good about "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("human culture, that which promotes human life. However, he advises that we must discern aspects of human culture that are affected by sin. This can only be done by long engagement, being present in particular contexts over time in order to know people and learn the issues they face. During this time, we practice discernment, speaking with a prophetic voice to affirm what is good and wholesome and to speak against what is evil and destructive."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn65",
      "id": "fn65"
    }
  }, [_vm._v("65")]), _vm._v(" As we identify redemptive analogies within the culture, we begin to proclaim the gospel of Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Jesus’s Gospel Witness")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In Jesus’s acts of feeding the crowds, healing the sick, restoring sight to the blind, and delivering the demonized, he carried out the cultural mandate by caring for human beings created in the image of God. Such acts demonstrated that he makes all things new, a promise that he will fulfill at his second coming (Rev. 21:5). In Jesus’s acts of preaching the gospel of the kingdom, forgiving sins, calling disciples to follow him, and sending out disciples to minister to others, he demonstrated the gospel’s disciple-making mandate. While the two mandates are distinct, we see how they come together in Jesus at the inauguration of his kingdom."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn66",
      "id": "fn66"
    }
  }, [_vm._v("66")])]), _vm._v(" The Gospel of Matthew says:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("After Jesus had finished instructing his twelve disciples, he went on from there to teach and preach in the towns of Galilee.")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("When John [the Baptist], who was in prison, heard about the deeds of the Messiah, he sent his disciples to ask him, “Are you the one who is to come, or should we expect someone else?”")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("Jesus replied, “Go back and report to John what you hear and see: The blind receive sight, the lame walk, those who have leprosy are cleansed, the deaf hear, the dead are raised, and the good news is proclaimed to the poor.” (Matt. 11:1–5)")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Jesus the Messiah-King announced the in-breaking of his kingdom in word and demonstrated it in deed. While he forgave the sins of the paralytic "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("man, he healed him of his paralysis (Luke 5:20–26)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn67",
      "id": "fn67"
    }
  }, [_vm._v("67")]), _vm._v(" Jesus addressed the whole spectrum of human needs, ministering to people physically, mentally, emotionally, socially, and spiritually. He met people at their point of need and spoke to them about the reality of their spiritual need. Often he would begin with physical needs and move to address people’s spiritual needs—their need of forgiveness of sin and reconciliation with God (Matt. 9:5; Mark 2:9; Luke 5:23; John 4:7, 10–15). Jesus Christ practiced holistic mission that maintained gospel priority (Luke 4:42–43)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn68",
      "id": "fn68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jesus, the Evangelist at the Well")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Jesus’s encounter with the Samaritan woman at the well at Sychar is particularly informative. He spoke not only of her need for water, a physical need, but also of her spiritual need for living water. His interactions with her serve as a model for gospel witness."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn69",
      "id": "fn69"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We read in John 4 that Jesus traveled through Samaria, and when he came to Jacob’s well, he sat down because he was tired from the journey. This happened about noon while his disciples were in town buying food. While he was there, a Samaritan woman came to draw water. Jesus initiated a conversation with the woman by asking, “Will you give me a drink?” (John 4:7). In response, the Samaritan woman said to him, “You are a Jew and I am a Samaritan woman. How can you ask me for a drink?” (John 4:9). She reacted to Jesus because, in part, Jews did not associate with Samaritans and certainly would never drink from the same container."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn70",
      "id": "fn70"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this encounter Jesus lived incarnationally; he lived out his incarnation. Although he was God-in-human-flesh, he took a posture of humility and need and asked the woman for water. In this missional act, he crossed racial, gender, class, and religious boundaries."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn71",
      "id": "fn71"
    }
  }, [_vm._v("71")])]), _vm._v(" For centuries, tensions had existed between Jews and Samaritans. Yet Jesus ignored social prejudices, "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("spoke kindly to the woman, and asked for her help."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn72",
      "id": "fn72"
    }
  }, [_vm._v("72")]), _vm._v(" He saw her as a bearer of the image of God and yet a sinner ("), _c('i', [_vm._v("simul creatus et peccator")]), _vm._v(") who needed to be restored to become a new creation, that is, to enter into the kingdom of God, to receive salvation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn73",
      "id": "fn73"
    }
  }, [_vm._v("73")])]), _vm._v(" Jesus answered her:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("“If you knew the gift of God and who it is that asks you for a drink, you would have asked him and he would have given you living water.”")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("“Sir,” the woman said, “you have nothing to draw with and the well is deep. Where can you get this living water? Are you greater than our father Jacob, who gave us the well and drank from it himself, as did also his sons and his livestock?”")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("Jesus answered, “Everyone who drinks this water will be thirsty again, but whoever drinks the water I give them will never thirst. Indeed, the water I give them will become in them a spring of water welling up to eternal life.”")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("The woman said to him, “Sir, give me this water so that I won’t get thirsty and have to keep coming here to draw water.” (John 4:10–15)")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Jesus piqued her interest and guided the conversation from the physical need of water that is common to all humans to her spiritual need for living water."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn74",
      "id": "fn74"
    }
  }, [_vm._v("74")])]), _vm._v(" He intentionally turned the conversation to spiritual matters, as well as to his identity as the Messiah. The open door in her statements allowed him to continue the conversation and to offer her “the water welling up to eternal life.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When Jesus told her to go, call her husband, and come back, she replied, “I have no husband.” So he said to her, “You are right when you say you have no husband. The fact is, you have had five husbands, and the man you now have is not your husband. What you have just said is quite true.” “Sir,” the woman said, “I can see that you are a prophet” (John 4:17–19). Not only was Jesus intentional to speak to her about spiritual matters, but now he directed the conversation to her personal life."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn75",
      "id": "fn75"
    }
  }, [_vm._v("75")])]), _vm._v(" With prophetic discernment, he raised the matter of her living with a man who was not her husband, yet doing so without shaming her. Her present situation was exposed. She may "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("have been an adulteress willfully cohabiting with a man and divorced previously by five husbands because of her infidelity, or she may have been barren and wrongfully divorced by five husbands because she was unable to bear them a child, leaving her disenfranchised, destitute, and desperate."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn76",
      "id": "fn76"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For whatever reason, perhaps in a moment of sensing her own guilt, shame, and need for self-justification or self-deflection, she turned the conversation toward the subject of religious pluralism or, at least, religious differences between the Jews and Samaritans. She attempted to draw Jesus into the centuries-old debate between Samaritans and Jews over the proper place to worship, saying, “Our ancestors worshiped on this mountain, but you Jews claim that the place where we must worship is in Jerusalem” (John 4:20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jesus did not debate the secondary issues of their religious differences, nor did he allow the conversation to get sidetracked. He spoke of worshiping God in Spirit and in truth. He replied, “Woman, believe me, a time is coming when you will worship the Father neither on this mountain nor in Jerusalem. You Samaritans worship what you do not know; we worship what we do know, for salvation is from the Jews. Yet a time is coming and has now come when the true worshipers will worship the Father in the Spirit and in truth, for they are the kind of worshipers the Father seeks. God is spirit, and his worshipers must worship in the Spirit and in truth” (John 4:21–24). Jesus respectfully corrected the woman’s misperceptions. He taught her about true worship, not appealing to the boundaries of religion but to the center: worshiping God the Father in truth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn77",
      "id": "fn77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In response she said, “I know that Messiah is coming. When he comes, he will explain everything to us” (John 4:25). She said this apparently in another attempt to highlight religious differences between Samaritans and Jews, and that the coming Messiah would resolve the debate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn78",
      "id": "fn78"
    }
  }, [_vm._v("78")])]), _vm._v(" However, her words about the expected Messiah opened the door further.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jesus straightforwardly declared, “I, the one speaking to you—I am he” (John 4:26). Truly, the promise of the Messiah to the descendants of Abraham and David had a face and a voice, and now the Messiah was looking at and speaking with this woman."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn79",
      "id": "fn79"
    }
  }, [_vm._v("79")])]), _vm._v(" She was confronted with a choice.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Samaritan Woman, a Person of Peace")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("As Jesus’s disciples returned, the Samaritan woman left her water jar, went back to the town of Sychar, and said to the people, “Come, see a man who told me everything I ever did. Could this be the Messiah?” (John 4:29). The people came out of the town and made their way toward Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this act, the Samaritan woman functioned as a person of peace, someone whom God prepared to bring the gospel to Sychar. Meanwhile, Jesus’s disciples urged him to eat something. Jesus then turned from his conversation with the woman about living water to a conversation with his disciples about spiritual food and the spiritual harvest, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("“I have food to eat that you know nothing about.”")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("Then his disciples said to each other, “Could someone have brought him food?”")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("“My food,” said Jesus, “is to do the will of him who sent me and to finish his work. Don’t you have a saying, ‘It’s still four months until harvest’? I tell you, open your eyes and look at the fields! They are ripe for harvest. Even now the one who reaps draws a wage and harvests a crop for eternal life, so that the sower and the reaper may be glad together. Thus the saying ‘One sows and another reaps’ is true. I sent you to reap what you have not worked for. Others have done the hard work, and you have reaped the benefits of their labor.” (John 4:32–38)")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The disciples then observed not merely the transformation of the Samaritan woman but the transformation of her entire town. She received Jesus as the Christ and then brought the good news of him to others. In fact, many of the Samaritans from that town believed in him because of the woman’s testimony, “He told me everything I ever did” (John 4:39). The Samaritans came to Jesus, urging him to stay with them, and he stayed two days. Because of his words, many more people in Sychar became believers. They said to the woman, “We no longer believe just because of what you said; now we have heard for ourselves, and we know that this man really is the Savior of the world” (John 4:42).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("In this encounter with the Samaritan woman, Jesus moved from addressing her common need for water to her spiritual need for living water and forgiveness and wholeness."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn80",
      "id": "fn80"
    }
  }, [_vm._v("80")]), _vm._v(" In this situation, Jesus was missional, "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("incarnational, conversational, holistic, intentional, respectful, personal, instructional, and evangelical."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn81",
      "id": "fn81"
    }
  }, [_vm._v("81")]), _vm._v(" The Samaritan woman, while sinful or sinned against, was nevertheless of great worth as an image-bearer of God, and Jesus treated her with respect. Although Jewish rabbis taught that a theological discussion with women, much less Samaritan women, was profaning of sacred things, Jesus disregarded such a view and engaged in this conversation of utmost spiritual depth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn82",
      "id": "fn82"
    }
  }, [_vm._v("82")])]), _vm._v(" As a sinner and seeker, the Samaritan woman came to accept Jesus as the Messiah. Her encounter with him changed her life. And as a person of peace, she brought the gospel to the people of Sychar."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn83",
      "id": "fn83"
    }
  }, [_vm._v("83")])]), _vm._v(" Jesus is the evangelist par excellence.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The mission of God is to redeem all creation and make all things new through his Son, Jesus Christ. The church participates with him in this redemptive work in the world. We engage in the "), _c('i', [_vm._v("cultural mandate")]), _vm._v(" and the "), _c('i', [_vm._v("disciple-making mandate")]), _vm._v(", which come together in word and deed in the mission of the church. At the center of this mission is the proclamation of the gospel, declaring to others what God has done through Jesus Christ, announcing forgiveness of sins, calling listeners to repentance and faith, and inviting them into Christ’s community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We engage our cultural contexts cautiously and critically, striving to be in the world but not of the world. Our differences from the world do not necessarily mean distance from the world. We exercise discernment and speak the truth of the gospel with prophetic discernment. We follow the example of Jesus by caring for image-bearers of God and by preaching the good news of the kingdom, calling people to follow him, and then sending them as disciples to proclaim the gospel to others.")]), _vm._v(" "), _c('p', {
    staticClass: "H3a"
  }, [_vm._v("DISCUSSION QUESTIONS")]), _vm._v(" "), _c('ol', {
    staticClass: "List1"
  }, [_c('li', [_vm._v("What are examples of human culture (an expression of the image of God in humanity) that reflect God’s goodness, beauty, and righteousness? What are examples of human culture that reflect the corruption of the image of God in humanity?")]), _vm._v(" "), _c('li', [_vm._v("As you consider what it means to be a witness to the good news of Jesus Christ, are you motivated mostly by the spiritual realities of the fallen human condition or the reconciled human condition? Why?")]), _vm._v(" "), _c('li', [_vm._v("How does a theology of creation, fall, and culture shape your understanding of mission and evangelism in the world?")]), _vm._v(" "), _c('li', [_vm._v("How would you describe your church’s perspective and posture toward human culture? Does it (1) separate from culture, (2) accommodate to culture, or (3) engage culture with discernment?")]), _vm._v(" "), _c('li', [_vm._v("How does Jesus’s conversation at Jacob’s well inform our evangelism to people who are different than us?")]), _vm._v(" "), _c('li', [_vm._v("Jesus crossed racial, gender, class, and religious boundaries when he spoke with the Samaritan woman. To which group of people locally or regionally may God be calling you? What boundaries would you need to cross?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". David J. Bosch, "), _c('i', [_vm._v("Transforming Mission: Paradigm Shifts in Theology of Mission")]), _vm._v(" (Maryknoll, NY: Orbis, 1991), 392. Cf. "), _c('i', [_vm._v("Cape Town Commitment")]), _vm._v(" (2010), which states, “The mission of God flows from the love of God. The mission of God’s people flows from our love for God and for all that God loves.” Cited in Harold A. Netland, "), _c('i', [_vm._v("Christianity and Religious Diversity: Clarifying Christian Commitments in a Globalizing Age")]), _vm._v(" (Grand Rapids: Baker Academic, 2015), 238.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". Bosch, "), _c('i', [_vm._v("Transforming Mission")]), _vm._v(", 390.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")]), _vm._v(". Ed Stetzer, “An Evangelical Kingdom Community Approach,” in "), _c('i', [_vm._v("The Mission of the Church: Five Views in Conversation")]), _vm._v(", ed. Craig Ott (Grand Rapids: Baker Academic, 2016), 96–101.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "rfn4"
    }
  }, [_vm._v("4")]), _vm._v(". Rom. 8:22–23; 2 Cor. 5:20; Rev. 21:5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "rfn5"
    }
  }, [_vm._v("5")]), _vm._v(". Roger E. Hedlund, "), _c('i', [_vm._v("The Mission of the Church in the World")]), _vm._v(" (Grand Rapids: Baker, 1991), 73; Craig Van Gelder and Dwight J. Zscheile, "), _c('i', [_vm._v("The Missional Church in Perspective")]), _vm._v(" (Grand Rapids: Baker Academic, 2011), 57.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "rfn6"
    }
  }, [_vm._v("6")]), _vm._v(". John R. W. Stott, "), _c('i', [_vm._v("Christian Mission in the Modern World")]), _vm._v(" (Downers Grove, IL: InterVarsity Press, 1975), 24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "rfn7"
    }
  }, [_vm._v("7")]), _vm._v(". Bosch, "), _c('i', [_vm._v("Transforming Mission")]), _vm._v(", 390, 400; Ross Hastings, "), _c('i', [_vm._v("Missional God, Missional Church: Hope for Re-evangelizing the West")]), _vm._v(" (Downers Grove, IL: IVP Academic, 2012), 77–78.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "rfn8"
    }
  }, [_vm._v("8")]), _vm._v(". Karl Barth, "), _c('i', [_vm._v("Church Dogmatics")]), _vm._v(", IV/1 (Edinburgh: T&T Clark, 2009), 725. Cf. John G. Flett, "), _c('i', [_vm._v("The Witness of God: The Trinity, “Missio Dei,” Karl Barth, and the Nature of Christian Community")]), _vm._v(" (Grand Rapids: Eerdmans, 2010), 30, 35–40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9",
      "id": "rfn9"
    }
  }, [_vm._v("9")]), _vm._v(". Jürgen Moltmann, "), _c('i', [_vm._v("The Church in the Power of the Spirit: A Contribution to Messianic Ecclesiology")]), _vm._v(" (New York: Harper & Row, 1977), 64. Cf. Darrell L. Guder, ed., "), _c('i', [_vm._v("Missional Church: A Vision for the Sending of the Church in North America")]), _vm._v(" (Grand Rapids: Eerdmans, 1998), 4–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10",
      "id": "rfn10"
    }
  }, [_vm._v("10")]), _vm._v(". Paul W. Chilcote and Laceye C. Warner, eds., "), _c('i', [_vm._v("The Study of Evangelism: Exploring a Missional Practice of the Church")]), _vm._v(" (Grand Rapids: Eerdmans, 2008), xx, xxvi.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11",
      "id": "rfn11"
    }
  }, [_vm._v("11")]), _vm._v(". Robert E. Coleman, "), _c('i', [_vm._v("The Master Plan of Evangelism")]), _vm._v(" (Grand Rapids: Spire, 1993), 99; Joe Aldrich, "), _c('i', [_vm._v("Lifestyle Evangelism: Learning to Open Your Life to Those around You")]), _vm._v(" (Sisters, OR: Multnomah, 1981), 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12",
      "id": "rfn12"
    }
  }, [_vm._v("12")]), _vm._v(". Bosch, "), _c('i', [_vm._v("Transforming Mission")]), _vm._v(", 519.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13",
      "id": "rfn13"
    }
  }, [_vm._v("13")]), _vm._v(". Jerry Root and Stan Guthrie, "), _c('i', [_vm._v("The Sacrament of Evangelism")]), _vm._v(" (Chicago: Moody, 2011), 61.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14",
      "id": "rfn14"
    }
  }, [_vm._v("14")]), _vm._v(". Matt. 3:9; Num. 22:28; Luke 2:8–15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15",
      "id": "rfn15"
    }
  }, [_vm._v("15")]), _vm._v(". Kynes and Strand state that the church is the centerpiece of God’s purposes for all humanity. Bill Kynes and Greg Strand, "), _c('i', [_vm._v("Evangelical Convictions: A Theological Exposition of the Statement of the Evangelical Free Church of America")]), _vm._v(" (Minneapolis: Free Church Publications, 2011), 182. The disciple-making mandate is also called the gospel mandate, spiritual mandate, new creation mandate, redemptive mandate, and the Great Commission.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "rfn16"
    }
  }, [_vm._v("16")]), _vm._v(". Mark 16:15; Matt. 28:18–20; Acts 10:36. The English "), _c('i', [_vm._v("gospel")]), _vm._v(" comes from "), _c('i', [_vm._v("gōdspel")]), _vm._v(": "), _c('i', [_vm._v("gōd")]), _vm._v(" “good” + "), _c('i', [_vm._v("spel")]), _vm._v(" “news.” The verb "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐαγγελίζοµαι")]), _vm._v(" ("), _c('i', [_vm._v("euangelizomai")]), _vm._v(") means “to evangelize” or “to preach the gospel” or “to gospelize.” The verb form occurs thirty-three times in the New Testament, and the noun form "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐαγγέλιον")]), _vm._v(" ("), _c('i', [_vm._v("euangelion")]), _vm._v("), translated as “gospel,” “good news,” or “evangel,” is found seventy-six times. The noun "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("εὐαγγελιστής")]), _vm._v(" ("), _c('i', [_vm._v("euangelistēs")]), _vm._v(") is translated as “evangelist,” “herald,” or “preacher of good news” and is found three times in the New Testament. David M. Gustafson, “Church Growth by Conversion: Creating Strategies That Observe the Principles of Evangelism” (DMin diss., Fuller Theological Seminary, 1995), 5–8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17",
      "id": "rfn17"
    }
  }, [_vm._v("17")]), _vm._v(". Matt. 5:9; 22:37–39; Luke 4:42b–3; 6:27–28; James 2:14–17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18",
      "id": "rfn18"
    }
  }, [_vm._v("18")]), _vm._v(". Article 5, “Christian Social Responsibility,” "), _c('i', [_vm._v("Lausanne Covenant")]), _vm._v(", 1974, in John R. W. Stott, "), _c('i', [_vm._v("The Lausanne Covenant: An Exposition and Commentary")]), _vm._v(" (Wheaton, IL: Lausanne Committee for World Evangelization, 1975), 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19",
      "id": "rfn19"
    }
  }, [_vm._v("19")]), _vm._v(". David J. Bosch notes perspectives of evangelism and social concern: “John Stott, and to a lesser extent the Lausanne Covenant, defines mission as evangelism plus social action. These two parts or aspects of mission are both important; indeed, they are imperative. The Lausanne Covenant adds, however, ‘In the church’s mission of sacrificial service evangelism is primary.’ . . . A second variation in the approach that regards mission as consisting of evangelism and social involvement is to state that these two expressions of mission are indeed genuinely different aspects of mission, but since they are equally important we should never try to prioritize. We may also say that they are so intimately intertwined that it would be futile to try to unravel them.” David J. Bosch, “Evangelism: Theological Currents and Cross-Currents Today,” in "), _c('i', [_vm._v("The Study of Evangelism: Exploring a Missional Practice of the Church")]), _vm._v(", ed. Paul W. Chilcote and Laceye C. Warner (Grand Rapids: Eerdmans, 2008), 8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20",
      "id": "rfn20"
    }
  }, [_vm._v("20")]), _vm._v(". Craig Ott and Stephen J. Strauss, "), _c('i', [_vm._v("Encountering Theology of Mission: Biblical Foundations, Historical Developments, and Contemporary Issues")]), _vm._v(" (Grand Rapids: Baker Academic, 2014), 73.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21",
      "id": "rfn21"
    }
  }, [_vm._v("21")]), _vm._v(". Eph. 2:15; Rev. 5:9–10; 7:9–10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22",
      "id": "rfn22"
    }
  }, [_vm._v("22")]), _vm._v(". In Matt. 28:19, "), _c('i', [_vm._v("panta ta ethnē")]), _vm._v(" refers to all tribes, nations, or peoples—to all segments of society without distinction. D. A. Carson, “Matthew,” in "), _c('i', [_vm._v("The Expositor’s Bible Commentary")]), _vm._v(", vol. 8, ed. Frank E. Gaebelein (Grand Rapids: Zondervan, 1984), 596. Cf. Lausanne Covenant, which states, “World evangelization requires the whole church to take the whole gospel to the whole world,” as does the Manila Manifesto. J. I. Packer and Thomas C. Oden, "), _c('i', [_vm._v("One Faith: The Evangelical Consensus")]), _vm._v(" (Downers Grove, IL: InterVarsity Press, 2004), 131–32, 135.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23",
      "id": "rfn23"
    }
  }, [_vm._v("23")]), _vm._v(". A Christian disciple is a person who professes to believe in and follow after Jesus Christ. This person “has come to him for eternal life, and has claimed him as Savior and God, and has embarked upon the life of following him.” Michael J. Wilkins, "), _c('i', [_vm._v("Following the Master: A Biblical Theology of Discipleship")]), _vm._v(" (Grand Rapids: Zondervan, 1992), 40–41. Cf. Bosch, “Evangelism,” 15: “Evangelism is calling people to become followers of Jesus.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24",
      "id": "rfn24"
    }
  }, [_vm._v("24")]), _vm._v(". Dietrich Bonhoeffer, "), _c('i', [_vm._v("The Cost of Discipleship")]), _vm._v(" (New York: Macmillan, 1963), 69.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25",
      "id": "rfn25"
    }
  }, [_vm._v("25")]), _vm._v(". John 10:27; 17:3; Phil. 3:9–10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26",
      "id": "rfn26"
    }
  }, [_vm._v("26")]), _vm._v(". Lynne Hybels and Bill Hybels, "), _c('i', [_vm._v("Rediscovering Church: The Story and Vision of Willow Creek Community Church")]), _vm._v(" (Grand Rapids: Zondervan, 1997), 167.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27",
      "id": "rfn27"
    }
  }, [_vm._v("27")]), _vm._v(". William J. Abraham, "), _c('i', [_vm._v("The Logic of Evangelism")]), _vm._v(" (Grand Rapids: Eerdmans, 1989), 44–45.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28",
      "id": "rfn28"
    }
  }, [_vm._v("28")]), _vm._v(". Bosch, “Evangelism,” 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29",
      "id": "rfn29"
    }
  }, [_vm._v("29")]), _vm._v(". Edward Rommen describes the Orthodox position of gospel proclamation as primarily introducing a person, Jesus Christ, rather than providing information about him. Edward Rommen, “A Sacramental Vision Approach,” in "), _c('i', [_vm._v("The Mission of the Church: Five Views in Conversation")]), _vm._v(", ed. Craig Ott (Grand Rapids: Baker Academic, 2016), 78. Cf. Root and Guthrie, "), _c('i', [_vm._v("Sacrament of Evangelism")]), _vm._v(", 214.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30",
      "id": "rfn30"
    }
  }, [_vm._v("30")]), _vm._v(". Matt. 11:28–30; Mark 1:15; Luke 9:57–62; 14:26–33. Bosch, “Evangelism,” 12, 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31",
      "id": "rfn31"
    }
  }, [_vm._v("31")]), _vm._v(". Mark 10:17–27; Acts 2:36; 17:7. Mortimer Arias, "), _c('i', [_vm._v("Announcing the Reign of God: Evangelization and the Subversive Memory of Jesus")]), _vm._v(" (Philadelphia: Fortress, 1984), xvii.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32",
      "id": "rfn32"
    }
  }, [_vm._v("32")]), _vm._v(". Stott, "), _c('i', [_vm._v("Christian Mission")]), _vm._v(", 39.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33",
      "id": "rfn33"
    }
  }, [_vm._v("33")]), _vm._v(". Several Greek words describe activities related to evangelism, in reference to the gospel. These include "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("λαλέω")]), _vm._v(" ("), _c('i', [_vm._v("laleō")]), _vm._v("), “to speak” (Acts 4:1), "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διδάσκω")]), _vm._v(" ("), _c('i', [_vm._v("didaskō")]), _vm._v("), “to teach” (Acts 4:2), "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("κηρύσσω")]), _vm._v(" ("), _c('i', [_vm._v("kēryssō")]), _vm._v("), “to proclaim” (Acts 8:5), "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("καταγγέλλω")]), _vm._v(" ("), _c('i', [_vm._v("katangellō")]), _vm._v("), “to announce publicly” (Acts 17:3), "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διαµαρτύροµαι")]), _vm._v(" ("), _c('i', [_vm._v("diamartyromai")]), _vm._v("), “to testify solemnly or bear witness” (Acts 18:5 ), and "), _c('span', {
    staticClass: "grk"
  }, [_vm._v("διαλέγοµαι")]), _vm._v(" ("), _c('i', [_vm._v("dialogomai")]), _vm._v("), “to reason” (Acts 18:4). Michael Green, "), _c('i', [_vm._v("Evangelism in the Early Church")]), _vm._v(" (Grand Rapids: Eerdmans, 1970), 48; Walter Klaiber, "), _c('i', [_vm._v("Call and Response: Biblical Foundations of a Theology of Evangelism")]), _vm._v(", trans. Howard Perry-Trauthig and James A. Dwyer (Nashville: Abingdon, 1997), 21–27.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34",
      "id": "rfn34"
    }
  }, [_vm._v("34")]), _vm._v(". Kynes and Strand, "), _c('i', [_vm._v("Evangelical Convictions")]), _vm._v(", 42–43.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35",
      "id": "rfn35"
    }
  }, [_vm._v("35")]), _vm._v(". D. A. Carson, "), _c('i', [_vm._v("The God Who Is There: Finding Your Place in God’s Story")]), _vm._v(" (Grand Rapids: Baker Books, 2010), 21–22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36",
      "id": "rfn36"
    }
  }, [_vm._v("36")]), _vm._v(". Stott, "), _c('i', [_vm._v("Lausanne Covenant")]), _vm._v(", 16; David S. Dockery, “A Theological Foundation for Evangelism,” in "), _c('i', [_vm._v("Evangelism in the Twenty-First Century: The Critical Issues")]), _vm._v(", ed. Thom S. Rainer (Wheaton, IL: Shaw, 1989), 78.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37",
      "id": "rfn37"
    }
  }, [_vm._v("37")]), _vm._v(". Carson, "), _c('i', [_vm._v("God Who Is There")]), _vm._v(", 22, 26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38",
      "id": "rfn38"
    }
  }, [_vm._v("38")]), _vm._v(". Christopher J. H. Wright, "), _c('i', [_vm._v("The Mission of God: Unlocking the Bible’s Grand Narrative")]), _vm._v(" (Downers Grove, IL: InterVarsity Press, 2013), 404–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39",
      "id": "rfn39"
    }
  }, [_vm._v("39")]), _vm._v(". Kynes and Strand, "), _c('i', [_vm._v("Evangelical Convictions")]), _vm._v(", 80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40",
      "id": "rfn40"
    }
  }, [_vm._v("40")]), _vm._v(". Carson, "), _c('i', [_vm._v("God Who Is There")]), _vm._v(", 35.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41",
      "id": "rfn41"
    }
  }, [_vm._v("41")]), _vm._v(". Derek Kidner, "), _c('i', [_vm._v("Genesis")]), _vm._v(", Tyndale Old Testament Commentaries (Downers Grove, IL: IVP Academic, 2016), 55; Kynes and Strand, "), _c('i', [_vm._v("Evangelical Convictions")]), _vm._v(", 75, 77–78.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42",
      "id": "rfn42"
    }
  }, [_vm._v("42")]), _vm._v(". Cf. Ps. 51:5; Isa. 64:6; cf. Rom. 3:10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43",
      "id": "rfn43"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('i', [_vm._v("Saint Augustine: Four Anti-Pelagian Writings")]), _vm._v(", trans. John Mourant and William Collinge (Washington, DC: Catholic University of America, 1992), 303, cited in Karl Barth, "), _c('i', [_vm._v("Church Dogmatics")]), _vm._v(", IV/3 (Edinburgh: T&T Clark, 1956), 567.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44",
      "id": "rfn44"
    }
  }, [_vm._v("44")]), _vm._v(". John L. Thompson, "), _c('i', [_vm._v("Genesis I–II")]), _vm._v(", Reformation Commentary on Scripture, Old Testament 1 (Downers Grove: IL: IVP Academic, 2012), 156–62.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn45",
      "id": "rfn45"
    }
  }, [_vm._v("45")]), _vm._v(". Kevin J. Vanhoozer, “Introduction: What Is Everyday Theology?,” in "), _c('i', [_vm._v("Everyday Theology: How to Read Cultural Texts and Interpret Trends")]), _vm._v(", ed. Kevin J. Vanhoozer, Charles A. Anderson, and Michael J. Sleasman (Grand Rapids: Baker Academic, 2007), 21–25; Samuel Escobar, "), _c('i', [_vm._v("The New Global Mission: The Gospel from Everywhere to Everyone")]), _vm._v(" (Downers Grove, IL: InterVarsity Press, 2003), 72.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn46",
      "id": "rfn46"
    }
  }, [_vm._v("46")]), _vm._v(". Vanhoozer, "), _c('i', [_vm._v("Everyday Theology")]), _vm._v(", 22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn47",
      "id": "rfn47"
    }
  }, [_vm._v("47")]), _vm._v(". David Bruce Hegeman, "), _c('i', [_vm._v("Plowing in Hope: Toward a Biblical Theology of Culture")]), _vm._v(" (Moscow, ID: Canon Press, 1999), 12–13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn48",
      "id": "rfn48"
    }
  }, [_vm._v("48")]), _vm._v(". Paul G. Hiebert, "), _c('i', [_vm._v("Anthropological Insights for Missionaries")]), _vm._v(" (Grand Rapids: Baker, 1985), 30.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn49",
      "id": "rfn49"
    }
  }, [_vm._v("49")]), _vm._v(". Richard Mouw, "), _c('i', [_vm._v("He Shines in All That’s Fair: Culture and Common Grace")]), _vm._v(" (Grand Rapids: Eerdmans, 2001), 43–46, 81–82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn50",
      "id": "rfn50"
    }
  }, [_vm._v("50")]), _vm._v(". Kynes and Strand, "), _c('i', [_vm._v("Evangelical Convictions")]), _vm._v(", 84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn51",
      "id": "rfn51"
    }
  }, [_vm._v("51")]), _vm._v(". Gal. 4:3; Col. 2:20; Titus 2:12. Russell Moore says that the Scriptures speak of “a world system that is at odds with the kingdom, a world to which we are constantly tempted to pattern our own intellects and affections after until we are interrupted by the ongoing transformation of the kingdom (Rom. 12:1).” Russell D. Moore, "), _c('i', [_vm._v("Onward: Engaging the Culture without Losing the Gospel")]), _vm._v(" (Nashville: B&H, 2015), 29.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn52",
      "id": "rfn52"
    }
  }, [_vm._v("52")]), _vm._v(". David F. Wells, "), _c('i', [_vm._v("Losing Our Virtue: Why the Church Must Recover Its Moral Vision")]), _vm._v(" (Grand Rapids: Eerdmans, 1999), 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn53",
      "id": "rfn53"
    }
  }, [_vm._v("53")]), _vm._v(". Vanhoozer, "), _c('i', [_vm._v("Everyday Theology")]), _vm._v(", 44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn54",
      "id": "rfn54"
    }
  }, [_vm._v("54")]), _vm._v(". Moore, "), _c('i', [_vm._v("Onward")]), _vm._v(", 29.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn55",
      "id": "rfn55"
    }
  }, [_vm._v("55")]), _vm._v(". Darrell L. Guder, "), _c('i', [_vm._v("Be My Witnesses: The Church’s Mission, Message and Messengers")]), _vm._v(" (Grand Rapids: Eerdmans, 1985), 80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn56",
      "id": "rfn56"
    }
  }, [_vm._v("56")]), _vm._v(". Kynes and Strand, "), _c('i', [_vm._v("Evangelical Convictions")]), _vm._v(", 84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn57",
      "id": "rfn57"
    }
  }, [_vm._v("57")]), _vm._v(". Ronald J. Sider, "), _c('i', [_vm._v("Good News and Good Works: A Theology for the Whole Gospel")]), _vm._v(" (Grand Rapids: Baker, 1999), 142, 148.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn58",
      "id": "rfn58"
    }
  }, [_vm._v("58")]), _vm._v(". See the Lausanne Committee for World Evangelization, “The Willowbank Report,” in "), _c('i', [_vm._v("Perspectives on the World Christian Movement: A Reader")]), _vm._v(", ed. Ralph D. Winter and Steven C. Hawthorne (Pasadena, CA: William Carey, 2009), 506–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn59",
      "id": "rfn59"
    }
  }, [_vm._v("59")]), _vm._v(". Tertullian, "), _c('i', [_vm._v("On the Prescription of Heretics")]), _vm._v(" 7, in C. Dodgson, "), _c('i', [_vm._v("Tertullian")]), _vm._v(", vol. 1, "), _c('i', [_vm._v("Apologetic and Practical Treatises")]), _vm._v(" (Oxford: John Henry Parker, 1842), 442. At the beginning of the church, the apostles taught at Solomon’s Porch (Acts 3:11).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn60",
      "id": "rfn60"
    }
  }, [_vm._v("60")]), _vm._v(". H. Richard Niebuhr, "), _c('i', [_vm._v("Christ and Culture")]), _vm._v(" (New York: Harper & Row, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn61",
      "id": "rfn61"
    }
  }, [_vm._v("61")]), _vm._v(". For a critique of Niebuhr see D. A. Carson, "), _c('i', [_vm._v("Christ and Culture Revisited")]), _vm._v(" (Grand Rapids: Eerdmans, 2008), 10, 36–45. For an adaption of Niebuhr see Timothy Keller, "), _c('i', [_vm._v("Center Church: Doing Balanced, Gospel-Centered Ministry in Your City")]), _vm._v(" (Grand Rapids: Zondervan, 2012), 194–95.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn62",
      "id": "rfn62"
    }
  }, [_vm._v("62")]), _vm._v(". Vanhoozer, "), _c('i', [_vm._v("Everyday Theology")]), _vm._v(", 18, 32. Cf. Michael Frost and Alan Hirsch, "), _c('i', [_vm._v("The Shaping of Things to Come: Innovation and Mission for the 21st-Century Church")]), _vm._v(" (Peabody, MA: Hendrickson, 2003), 16. Kevin Harney warns against “cultural voyeurism” and the “cultural gravity” that can pull one toward behavior that dishonors God. With this warning he advocates going where God leads, even if he calls us to dark and difficult places. Kevin G. Harney, "), _c('i', [_vm._v("Organic Outreach for Ordinary People: Sharing Good News Naturally")]), _vm._v(" (Grand Rapids: Zondervan, 2009), 132–34.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn63",
      "id": "rfn63"
    }
  }, [_vm._v("63")]), _vm._v(". Lausanne Covenant, §10, in Packer and Oden, "), _c('i', [_vm._v("One Faith")]), _vm._v(", 138.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn64",
      "id": "rfn64"
    }
  }, [_vm._v("64")]), _vm._v(". Wright, "), _c('i', [_vm._v("Mission of God")]), _vm._v(", 447.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn65",
      "id": "rfn65"
    }
  }, [_vm._v("65")]), _vm._v(". Jim Belcher, "), _c('i', [_vm._v("Deep Church: A Third Way beyond Emerging and Traditional")]), _vm._v(" (Downers Grove, IL: InterVarsity Press, 2009), 184–90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn66",
      "id": "rfn66"
    }
  }, [_vm._v("66")]), _vm._v(". Arthur F. Glasser et al., "), _c('i', [_vm._v("Announcing the Kingdom: The Story of God’s Mission in the Bible")]), _vm._v(" (Grand Rapids: Baker Academic, 2003), 39.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn67",
      "id": "rfn67"
    }
  }, [_vm._v("67")]), _vm._v(". Both aspects of this encounter had eschatological significance, pointing to the fullness of his kingdom when sin and sickness will be defeated finally (1 Cor. 15:25–26; Rev. 21:4).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn68",
      "id": "rfn68"
    }
  }, [_vm._v("68")]), _vm._v(". John R. W. Stott, "), _c('i', [_vm._v("The Contemporary Christian")]), _vm._v(" (Downers Grove, IL: InterVarsity Press, 1995), 337–55.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn69",
      "id": "rfn69"
    }
  }, [_vm._v("69")]), _vm._v(". F. F. Bruce, "), _c('i', [_vm._v("The Gospel of John: Introduction, Exposition, and Notes")]), _vm._v(" (Grand Rapids: Eerdmans, 1983), 116.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn70",
      "id": "rfn70"
    }
  }, [_vm._v("70")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 103.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn71",
      "id": "rfn71"
    }
  }, [_vm._v("71")]), _vm._v(". D. A. Carson, "), _c('i', [_vm._v("The Gospel according to John")]), _vm._v(" (Grand Rapids: Eerdmans, 1991), 217–18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn72",
      "id": "rfn72"
    }
  }, [_vm._v("72")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 103.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn73",
      "id": "rfn73"
    }
  }, [_vm._v("73")]), _vm._v(". Carson, "), _c('i', [_vm._v("Gospel According to John")]), _vm._v(", 227. Frederick Godet observes, “He is not unaware that the way to gain a soul is often to ask a service of it.” Frederick Louis Godet, "), _c('i', [_vm._v("Commentary on the Gospel of John")]), _vm._v(" (Grand Rapids: Zondervan, 1969), 1:422.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn74",
      "id": "rfn74"
    }
  }, [_vm._v("74")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 104.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn75",
      "id": "rfn75"
    }
  }, [_vm._v("75")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 106.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn76",
      "id": "rfn76"
    }
  }, [_vm._v("76")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 107; Raphael Patai, "), _c('i', [_vm._v("Sex and Family in the Bible and the Middle East")]), _vm._v(" (Garden City, NY: Doubleday, 1959), 57, 114–20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn77",
      "id": "rfn77"
    }
  }, [_vm._v("77")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 109; Gary M. Burge, "), _c('i', [_vm._v("John")]), _vm._v(", The NIV Application Commentary (Grand Rapids: Zondervan, 2000), 142.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn78",
      "id": "rfn78"
    }
  }, [_vm._v("78")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 110.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn79",
      "id": "rfn79"
    }
  }, [_vm._v("79")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 111.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn80",
      "id": "rfn80"
    }
  }, [_vm._v("80")]), _vm._v(". James H. Jauncey, "), _c('i', [_vm._v("Psychology for Successful Evangelism")]), _vm._v(" (Chicago: Moody, 1972), 39; Delos Miles, "), _c('i', [_vm._v("Master Principles of Evangelism")]), _vm._v(" (Nashville: Broadman Press, 1982), 32–33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn81",
      "id": "rfn81"
    }
  }, [_vm._v("81")]), _vm._v(". The word "), _c('i', [_vm._v("evangelical")]), _vm._v(" here is used to describe the message of Jesus as bearing good news. Of course, historical usage of the word "), _c('i', [_vm._v("evangelical")]), _vm._v(" defines Christians that emphasize (1) the Bible as the Word of God, (2) the cross as the means of salvation, (3) conversion as necessary for all, and (4) missionary activity. Packer and Oden, "), _c('i', [_vm._v("One Faith")]), _vm._v(", 19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn82",
      "id": "rfn82"
    }
  }, [_vm._v("82")]), _vm._v(". Burge, "), _c('i', [_vm._v("John")]), _vm._v(", 148.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn83",
      "id": "rfn83"
    }
  }, [_vm._v("83")]), _vm._v(". Bruce, "), _c('i', [_vm._v("Gospel of John")]), _vm._v(", 115.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a99baa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter002.vue
// module id = 78
// module chunks = 0